// extracted by mini-css-extract-plugin
export default {"container":"w5Ntvhi9mBit6F1UWkvK","arrow":"AwNyC1_cNwtp7VLD1Q4V"};